import clsx from "clsx";
import { t } from "i18next";

export const Themes: { [key: string]: string } = {
  default:
    "bg-gray-950 dark:bg-zinc-950 text-white hover:bg-gray-800 dark:hover:bg-zinc-950/40 focus:ring-gray-600 dark:focus:ring-zinc-800",
  secondary:
    "border border-gray-200 dark:bg-zinc-800 dark:text-zinc-300 dark:hover:bg-zinc-700 dark:border-0 bg-gray-100 text-gray-950 hover:bg-gray-200 focus:ring-gray-200 dark:focus:ring-zinc-800",
  third:
    "border border-gray-200 text-gray-950 hover:bg-gray-100 focus:ring-gray-200 dark:border-zinc-800 dark:text-white dark:hover:bg-zinc-700 dark:focus:ring-zinc-700",
  success:
    "bg-green-500 text-white hover:bg-green-600 focus:ring-green-200 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-700/60",
  "outline-success":
    "border border-emerald-300 text-emerald-600 hover:bg-emerald-50 focus:ring-emerald-200 dark:border-emerald-800 dark:text-emerald-400 dark:hover:bg-emerald-900 dark:focus:ring-emerald-700/60",
  dangers: "bg-red-600 text-white hover:bg-red-500 focus:ring-red-200",
  "outline-dangers":
    "border border-red-300 text-red-600 hover:bg-red-50 focus:ring-red-200 dark:border-red-400 dark:text-red-500 dark:hover:bg-red-900/50 dark:focus:ring-red-700",
  gray: "bg-gray-300 text-white hover:bg-gray-200 focus:ring-gray-100",
  yellow: "bg-yellow-500 text-white hover:bg-yellow-600 focus:ring-yellow-100",
  green:
    "bg-emerald-500 text-white hover:bg-emerald-600 focus:ring-emerald-100",
  blue: "bg-blue-500 text-white hover:bg-blue-600 focus:ring-blue-100",
  sky: "bg-sky-500 text-white hover:bg-sky-600 focus:ring-sky-100",
  rose: "bg-rose-600 text-white hover:bg-rose-500 focus:ring-rose-200",
  indigo: "bg-indigo-600 text-white hover:bg-indigo-500 focus:ring-indigo-200",
  "secondary-yellow":
    "bg-yellow-100/60 text-yellow-800 ring-yellow-500/20 hover:bg-yellow-200/80 dark:hover:bg-yellow-900 dark:bg-yellow-900/50 dark:text-yellow-300 dark:ring-yellow-700/20",
  "secondary-green":
    "bg-emerald-100/60 text-emerald-800 ring-emerald-500/20 hover:bg-emerald-200/80 dark:hover:bg-emerald-900 dark:bg-emerald-900/50 dark:text-emerald-300 dark:ring-emerald-700/20",
  "secondary-blue":
    "bg-blue-100/60 text-blue-800 ring-blue-500/20 hover:bg-blue-200/80 dark:hover:bg-blue-900 dark:bg-blue-900/50 dark:text-blue-300 dark:ring-blue-700/20",
  "secondary-sky":
    "bg-sky-100/60 text-sky-800 ring-sky-500/20 hover:bg-sky-200/80 dark:hover:bg-sky-900 dark:bg-sky-900/50 dark:text-sky-300 dark:ring-sky-700/20",
  "secondary-indigo":
    "bg-indigo-100/60 text-indigo-800 ring-indigo-500/20 hover:bg-indigo-200/80 dark:hover:bg-indigo-900 dark:bg-indigo-900/50 dark:text-indigo-300 dark:ring-indigo-700/20",
  "secondary-rose":
    "bg-rose-100/60 text-rose-800 ring-rose-500/20 hover:bg-rose-200/80 dark:hover:bg-rose-900 dark:bg-rose-900/50 dark:text-rose-300 dark:ring-rose-700/20",
};

export default function Button({
  title,
  type = "button",
  icon: Icon,
  className,
  iconClassName,
  children,
  disabled,
  color = "default",
  onClick,
  isLoading,
}: {
  title?: string;
  type?: "button" | "submit" | "reset" | undefined;
  icon?: any;
  className?: string;
  iconClassName?: string;
  children?: any;
  disabled?: boolean;
  color?: keyof typeof Themes;
  onClick?: (e: any) => void;
  isLoading?: boolean;
}) {
  return (
    <button
      type={type}
      className={clsx(
        "focus:ring-opacity-60 flex items-center justify-center gap-x-2 rounded-lg px-4 py-2 text-center text-sm tracking-wide capitalize transition-colors duration-300 focus:ring-3 focus:outline-hidden",
        Themes[color],
        className,
        disabled ? "cursor-not-allowed opacity-70" : "",
      )}
      disabled={disabled || isLoading}
      onClick={onClick}
    >
      {isLoading ? (
        <svg
          className="h-5 w-5 animate-spin text-white"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
      ) : (
        Icon && <Icon className={clsx("h-5 w-5", iconClassName)} />
      )}
      {children ? children : title && t(title)}
    </button>
  );
}
